import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { fetchHighLights } from "../../../api/scheduleApi";
import UserHelper from '../../../common/utils/userHelper';
import { getImage } from '../../../utils/helper.ts';
import _ from "lodash";
import { highlightTitle } from '../../../utils/htmlHelper.tsx';

interface AboutProps {
    landingPageData: any; 
    label: string;
  }

const HighLights: React.FC<AboutProps> = ({landingPageData,label}) => {
  // Slider settings
  const eventId = UserHelper.getEventId();
    const [data, setData] = useState<any>();
    const eventData = useSelector((state: any) => state.eventData, shallowEqual);
    const text = landingPageData?.on_demand_text || '';
    const eventTitle = eventData?.title || '';
    const themePrimaryColor = eventData.primary_color;

  
    useEffect(() => {
      const fetchHighLightsData = async () => {
        try {
          let response = await fetchHighLights(eventId);
          console.log('Exhibiton page data:', response);
          setData(response);
        } catch (error) {
          console.error('Error fetching gallery page data:', error);
        }
      };
  
      fetchHighLightsData();
    }, [eventId]);
    
    if (!data || data.length === 0) {
        return null;
    }
  return (

    <div className="single-section silver-bg pricing-area" id="agenda">
    <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="section-heading">
                    <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>

                    <p className="section-description col-lg-12 col-md-10 col-sm-12">
                        {highlightTitle(text, eventTitle,themePrimaryColor)}
                      
                    </p>
                </div>
            </div>
        </div>
        <div className="row">

        {data && data.length > 0 &&
            _.map(data, (rt, key) => {
                const title = UserHelper.getEventTitle(rt.translations) || "";
                const words = title.trim().split(/\s+/);

              let firstPart = "";
              let remainingPart = "";

              if (words.length === 1) {
                // whole title is colored
                firstPart = title;
                remainingPart = "";
              } else {
                // first word colored, rest normal
                firstPart = words[0];
                remainingPart = words.slice(1).join(" ");
              }

                return (
                <div className="col-lg-12 pb-3" key={key}>
                    <div className="single-plan mb-4 mb-sm-5 mb-lg-0"  >
                    <div className="plan-head" >
                        <h2 className="plan-price">
                         {title} 
                        </h2>
                    </div>
                    <div className="section-description mb-sm-5 mb-lg-0" style={{ margin: '0 auto', padding: '10px 20px'}}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: UserHelper.getEventDescription(rt),
                    }}
                  />
                </div>
                   
                    </div>
                </div>
                );
            })  
        }

            
            
            
        </div>
    </div>
</div>
  );
};

export default HighLights;

